import Tablesalereportmonth from '../tablesalereportmonth/tablesalereportmonth.vue'
import TableSalesReportsBroker from '../tablesalesreportsbroker/tablesalesreportsbroker.vue'
import ProposalRepository from '@/shared/http/repositories/realestate/proposal'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'BoardSaledReportsBroker',
  components: {Tablesalereportmonth, TableSalesReportsBroker},
  props: ['mes', 'dataSalesProp', 'posicaoMes'],
  data () {
    return {
      columns: ['VENDAS', 'VALOR', 'QUANTIITEM'],
      changeAngel: false,
      dataProposta: [],
      dataEnterprise: [],
      dataEnterpriseVM: [],
      dataCalculo: [],
      dataSales: [],
      reportEnterprise: []
    }
  },
  mounted () {
    this.dataSales = this.dataSalesProp
    let enterpriseNames = []
    this.dataSales.forEach(sale => {
      if (!enterpriseNames.includes(sale.nomeEmpreendimento)) {
        enterpriseNames.push(sale.nomeEmpreendimento)
      }
    })
    enterpriseNames.forEach(enterpriseName => {
      this.reportEnterprise.push(
        this.dataSales.filter(sale => sale.nomeEmpreendimento === enterpriseName)
      )
    })
  },
  methods: {
    GetAllNomeEPRoposta () {
      ProposalRepository.GetAllNomeEPRoposta()
        .then(response => {
          this.dataProposta = response.data.data
        })
        .catch(() => {})
    },
    GetAllEnterprise () {
      EnterpriseRepository.GetAllNotPaging()
        .then(response => {
          this.dataEnterprise = response.data.coretoresData
        })
        .catch(() => {})
    },
    SetDataSales (newDataSales) {
      this.dataSales = newDataSales
      if (this.reportEnterprise.length === 0) {
        let enterpriseNames = []
        this.dataSales.forEach(sale => {
          if (!enterpriseNames.includes(sale.nomeEmpreendimento)) {
            enterpriseNames.push(sale.nomeEmpreendimento)
          }
        })
        enterpriseNames.forEach(enterpriseName => {
          this.reportEnterprise.push(
            this.dataSales.filter(sale => sale.nomeEmpreendimento === enterpriseName)
          )
        })
      }
    },
    GetAllRelatorio () {
      loading.push()
      ProposalRepository.GetAllRelatorio()
        .then(response => {
          response.data.data.forEach(element => {
            element.coretoresData = []
            element.corretor.forEach((corretor) => {
              element.coretoresData.push(corretor)
              this.dataEnterprise.push(corretor)
            })
          })
          this.dataCalculo = response.data.data
          loading.pop()
        })
        .catch(() => {
          loading.pop()
        })
    },
    Search (obj) {
      loading.push()
      ProposalRepository.Search(obj)
        .then(response => {
          response.data.data.forEach(element => {
            element.coretoresData = []
            loading.pop()
            element.corretor.forEach((corretor) => {
              element.coretoresData.push(corretor)
            })
          })
          this.dataCalculo = response.data.data
          loading.pop()
        })
        .catch(() => {
          loading.pop()
        })
    },
    getDataSales () {
      this.$emit('getDataSales', this.posicaoMes)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesreportsbroker/components/boardsalesreportsbroker/boardsaledreportsbroker.js